import { terminateTokens } from "./api/utils/localStorage";

export const crossTabLogoutChannel = new BroadcastChannel("logout");

crossTabLogoutChannel.onmessage = (e) => {
  if (e.data === "LOGOUT") {
    terminateTokens();
    window.location.reload();
  }
};
